import { NgModule } from '@angular/core';
import { LoadAndQueryDevPageComponent } from './pages/report-devoluciones-page.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDevolucionesComponent } from './modal-devoluciones/modal-devoluciones.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [LoadAndQueryDevPageComponent, ModalDevolucionesComponent],
    exports: [LoadAndQueryDevPageComponent],
    imports: [CommonModule, FormsModule, RouterModule, TranslateModule],
})
export class NovedadesModule {}
